<template>
    <!-- htmlText is data.name -->
    <div class="d-flex align-items-center" v-if="data.type == 'NAME'">
        <img
            class="rounded-circle"
            :src="data.imgLink"
            style="width: 30px; height: 30px;" />
        <!-- Note: the v-html binding is used, as htmlText contains
            the suggestion text highlighted with <strong> tags -->
        <div>
            <span class="ml-4 font-weight-bold" v-html="htmlText" style="display:block"></span>
            <span class="ml-4 text-muted" v-html="data.subText"></span>
        </div>
        <i class="ml-auto fab fa-github-square fa-2x"></i>
    </div>
    <div v-else-if="data.type == 'TAG'">
        <span class="ml" v-html="htmlText"></span>
    </div>
    <div v-else>
        <!-- DEFAULT -->
        <img
            class="rounded-circle"
            :src="data.imgLink"
            style="width: 20px; height: 20px;" />
        <span class="ml-4" v-html="htmlText"></span>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    components: {

    },
    props: {
        data: {
            type: Object,
        },
        htmlText: {
            type: String,
        }
    }
}
</script>